import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-schedule-task-dialog',
  templateUrl: './view-schedule-task-dialog.component.html',
  styleUrls: ['./view-schedule-task-dialog.component.scss']
})
export class ViewScheduleTaskDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
